import { FC, useCallback, useEffect, useState } from "react";
import { AppLoader } from "../../../components/loading/LoadingOverlay";
import { DatePicker, IconButton, Loader } from "rsuite";
import { formatDate } from "../../../../util/date";
import { FaIcon } from "../../../components/fontawesome/icon";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { toRelativeCalendar } from "../../../../lib/date";
import { useNavigate } from "react-router-dom";
import { UserIncident } from "../../../../domain/incident/Incident";
import { useIncidentGroupViewModel } from "../../../../viewmodel/incident-group/IncidentGroup";
import { useQuery } from "../../../../hook/query";
import { DateTime } from "luxon";
import { toInteger } from "lodash";
import { useQueryNavigate } from "../../../../hook/navigate";
import { ByRequestIncidentModal } from "./component/modal";
import { IncidentGroupByRequestData } from "./component/data";

export const ByRequestIncidentGroup: FC<any> = () => {
  const queryTimestamp = useQuery().get("timestamp");
  const initialSelectedTime = queryTimestamp
    ? DateTime.fromMillis(toInteger(queryTimestamp)).toJSDate()
    : new Date();
  const [selectedTime, setSelectedTime] = useState(initialSelectedTime);
  const [selection, setSelection] = useState<UserIncident | null>(null);
  const queryNavigate = useQueryNavigate();
  const {
    fetchState,
    fetchUserIncidentList,
    onFetchStateReceived,
    userIncidentTimestamp,
    userIncidentList,
    refreshEvent,
    requestRefreshEvent,
    onRefreshEventCompleted
  } = useIncidentGroupViewModel();
  const navigate = useNavigate();

  /* eslint-disable */
  useEffect(() => {
    void fetchUserIncidentList(selectedTime.getTime());
  }, [selectedTime]);

  useEffect(() => {
    if (fetchState && !fetchState.isLoading()) {
      if (fetchState.isFailed()) {
        window.toast.error(
          "Ocurrió un error al obtener la lista de incidencias."
        );
        console.log(fetchState?.error);
      }
      onFetchStateReceived();
    }
  }, [fetchState]);

  useEffect(() => {
    if (refreshEvent) {
      void fetchUserIncidentList(selectedTime.getTime(), true);
      onRefreshEventCompleted();
    }
  }, [refreshEvent]);

  const onTableItemSelected = useCallback((item: UserIncident) => {
    navigate(
      `/dashboard/incident?reference=${encodeURIComponent(item.reference)}`
    );
  }, []);

  const onTablePreviewActionClicked = useCallback((item: UserIncident) => {
    setSelection(item);
  }, []);

  const onModalClosed = useCallback(() => {
    setSelection(null);
  }, []);
  /* eslint-enable */

  const loading = fetchState?.loading || undefined;

  return (
    <div
      className={"w-full h-full flex flex-col p-3 gap-0 overflow-hidden"}
    >
      <AppLoader isActive={loading} />
      {!!selection ? (
        <ByRequestIncidentModal
          incident={selection}
          onClose={onModalClosed}
        />
      ) : null}
      <div
        className={
          "flex-none w-full flex flex-row flex-wrap gap-2 p-2 border-b-2 border-neutral-100 overflow-x-hidden items-center justify-between"
        }
      >
          <span className={"text-lg font-normal text-neutral-600 uppercase"}>
            {formatDate(selectedTime)}
          </span>
        <div className={"flex flex-row flex-wrap items-center gap-2"}>
          <div className={"flex flex-row flex-wrap gap-2 items-center z-0"}>
            <span>Seleccionar fecha</span>
            <DatePicker
              value={selectedTime}
              onChange={(newDate) => {
                if (
                  !!newDate &&
                  newDate?.getTime() !== selectedTime.getTime()
                ) {
                  setSelectedTime(newDate);
                  queryNavigate({
                    timestamp: newDate.getTime()
                  });
                }
              }}
            />
          </div>
          <IconButton
            size={"sm"}
            appearance={"primary"}
            onClick={requestRefreshEvent}
            icon={<FaIcon icon={faRefresh} />}
          >
            Actualizar
          </IconButton>
        </div>
      </div>
      {fetchState?.isLoading() ? (
        <Loader center backdrop size={"sm"} content={"Cargando..."} />
      ) : (
        <div
          className={
            "flex-1 w-full h-full flex justify-center sm:items-center overflow-hidden"
          }
        >
          <div className={"w-full h-full flex flex-col"}>
            {userIncidentTimestamp ? (
              <div className={"w-full flex-none p-2"}>
                <p>
                    <span className={"text-neutral-400 uppercase"}>
                      Última actualización:{" "}
                    </span>
                  {toRelativeCalendar(userIncidentTimestamp.timestamp, true)}
                </p>
              </div>
            ) : null}
            <div className={"w-full flex-1 overflow-x-hidden"}>
              <IncidentGroupByRequestData
                onClick={onTableItemSelected}
                onPreview={onTablePreviewActionClicked}
                items={userIncidentList}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
